import Resource from './common/resource';

class Fields extends Resource {
  path = 'fields';

  onDeleteOne({ commit }, { model }) {
    commit('fields/deleteFieldInBucket', { model }, { root: true });
  }

  onCreateOne({ dispatch, commit }, { model, res }) {
    model.id = res.data.id;
    commit('fields/updateFieldInBucket', { model }, { root: true });
    dispatch('fields/loadOne', { path: res.data.id }, { root: true });
  }

  onLoadOne({ dispatch, commit }, { model, res }) {
    if (model?.id) {
      dispatch('fields/loadOne', { path: model.id }, { root: true });
      return;
    }

    const data = model?.id ? model : res.data;
    commit('fields/updateFieldInBucket', { model: data }, { root: true });
  }
}

export default Fields;
